import React from 'react';
import CollectionItem from './CollectionItem';
import AutocompleteSelect from './AutocompleteSelect';
import PictureInput from './PictureInput';

export default props => {
    return <CollectionItem onDelete={props.onDelete}>
        <PictureInput
            label="Picture"
            placeholderPicture={props.value.picture ? props.value.picture.displayPath : ''}
            value={props.value.picture ? props.value.picture : null}
            onChange={v => props.onChange('picture', v)}
        />
        <AutocompleteSelect
            label="Type"
            options={props.parentProps.options}
            optionLabel={t => t.name}
            value={props.value.type ? props.value.type : null}
            variant="standard"
            onChange={v => props.onChange('type', v)}
        />
    </CollectionItem>;
};
